import { render, staticRenderFns } from "./CorporateCategoryCreate.vue?vue&type=template&id=07bd9150"
import script from "./CorporateCategoryCreate.vue?vue&type=script&lang=js"
export * from "./CorporateCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports